export enum EditFormMode {
  CrudRoute = "CrudRoute",
  UnboundDrawer = "UnboundDrawer",
  DropdownAddDrawer = "DropdownAddDrawer",
}
